import axios from 'axios'

export const fetchUsers = async() => {
  try {
    return await axios.get(`users`)
  } catch (error) {
    throw error.response
  }
}

export const fetchUser = async(id) => {
  try {
    return await axios.get(`users/${id}`)
  } catch (error) {
    throw error.response
  }
}

export const createUser = async(data) => {
  try {
    return await axios.post(`users`, data)
  } catch (error) {
    throw error.response
  }
}

export const updateUser = async(id, data) => {
  try {
    return await axios.patch(`users/${id}`, data)
  } catch (error) {
    throw error.response
  }
}

export const deleteUser = async(id) => {
  try {
    return await axios.delete(`users/${id}`)
  } catch (error) {
    throw error.response
  }
}

export const toggleActive = async(id) => {
  try {
    return await axios.put(`users/${id}/active`)
  } catch (error) {
    throw error.response
  }
}
